import { render } from "./FormPropertyView.vue?vue&type=template&id=21a848d9"
import script from "./FormPropertyView.vue?vue&type=script&lang=js"
export * from "./FormPropertyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__